import { useEffect, useState, useCallback } from 'react';
import { api } from '../lib/api';

export function useLatestStats(refreshIntervalMs = 60_000) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchOnce = useCallback(async () => {
    try {
      const { data: res } = await api.get('/stats/latest');
      setData(res);
    } catch (err) {
      console.error('latest stats failed', err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchOnce();
    const id = setInterval(fetchOnce, refreshIntervalMs);
    return () => clearInterval(id);
  }, [fetchOnce, refreshIntervalMs]);

  return { data, loading, refetch: fetchOnce };
}
